import styled from '@emotion/styled'
import { Sidebar } from 'flipper-ui'
import { FlexColumn } from '@core/commonStyles'
import { theme } from 'flipper-ui/theme'

const { gray, primary } = theme.colors

export const Link = styled.a`
    color: ${primary.main};
    text-decoration: none;
`

export const PaperBar = styled(FlexColumn)`
    justify-content: space-between;
    height: 88%;
`

export const FlipperSidebar = styled(Sidebar)`
    && {
        transition: width 500ms ease-in-out;
    }

    & > div {
        border-right: 1px solid ${gray[300]};
    }
`
